import { render, staticRenderFns } from "./ListObjectives.vue?vue&type=template&id=4178ec52&"
import script from "./ListObjectives.vue?vue&type=script&lang=js&"
export * from "./ListObjectives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports